export default __webpack_public_path__ + "static/media/img_03.235cbb9f.png";